import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VendorViewForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'kreditorer', dataApiName: 'VendorView', text: 'Kreditorer', textSingular: 'Kreditor',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'history'], 
      allowEdit: false, allowCreate: false, allowDelete: false, 
      navigations: [
        { link: ['fk','navMenu'], title: 'Kreditor (rediger)', foreignKey: {parentEntity: 'Vendor', parentColumn: 'num', column: 'num'} },
        { link: 'navMenu', foreignKey: { parentEntity: 'VoucherPostingVendor', parentColumn: 'vendorNum', column: 'num'} },
        { link: 'navMenu', foreignKey: { parentEntity: 'VendorTrans', parentColumn: 'num', column: 'num'} }
      ]
    };

    view.fieldMetadata = [
      { name: 'num', allowEdit: false, visibleAdd: false, orderBy: 'Ascending', orderByPriority: 2, fieldType: 'vendor' },
      { name: 'name', text: 'Navn', tooltipText: 'Navn på part', widthType: FieldWidthEnum.XL },
      { fieldType: 'currency' },
      { name: 'group', widthType: FieldWidthEnum.XS, fieldType: 'vendorGroup' },
      { name: 'taxCode', text: 'Momskode', widthType: FieldWidthEnum.XS, fieldType: 'financeTaxCode' },
      { name: 'approved', text: 'Godkendt', format: 'CheckBox', visible: false },
      { name: 'blocked', text: 'Spærret', format: 'CheckBox', orderBy: 'Ascending', orderByPriority: 1 },
      { fieldType: 'paymentTerm' },
      { name: 'bankAccount', text: 'Bankkonto', tooltipText: 'Lokalt kontonr.', widthType: FieldWidthEnum.XL},
      { name: 'taxId', text: 'Momsnr.'},
      { name: 'taxIdType', text: 'Moms type'},
      { fieldType: 'phone', widthType: FieldWidthEnum.XS },
      { fieldType: 'mobile', widthType: FieldWidthEnum.XS },
      { fieldType: 'email',widthType: FieldWidthEnum.XS },
      { name: 'address1', text: 'Adresse 1', widthType: FieldWidthEnum.M },
      { name: 'address2', text: 'Adresse 2', widthType: FieldWidthEnum.M  },
      { name: 'address3', text: 'Adresse 3', widthType: FieldWidthEnum.M  },
      { name: 'country', text: 'Land', widthType: FieldWidthEnum.S  },
      { name: 'attention', text: 'Attention', widthType: FieldWidthEnum.M , visible: false }
    ];

    return view;
  }
}
